import { render, staticRenderFns } from "./PainterMakeOrderDetails.vue?vue&type=template&id=0b71424a&scoped=true"
import script from "./PainterMakeOrderDetails.vue?vue&type=script&lang=js"
export * from "./PainterMakeOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./PainterMakeOrderDetails.vue?vue&type=style&index=0&id=0b71424a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b71424a",
  null
  
)

export default component.exports